import { FormDataAction, FormDataActionTypes } from './form-data.actions';

export function FormDataReducers(state , action: FormDataAction): any {
  switch (action.type) {
    case FormDataActionTypes.LoadFormData: {
      return action.payload;
    }
    case FormDataActionTypes.LoadFormDataWithSync: {
      const data = {...action.payload};
      const stateData = {...state};
      let sectionData: any = {};
      let sectionStateData: any = {};
      const caregiverSyncData: any = [];
      let caregiverData = [];
      sectionData = data.investigation.json_data;
      if (typeof sectionData === 'string') {
          sectionData = JSON.parse(sectionData);
      }
      if (stateData.investigation !== undefined) {
        sectionStateData = stateData.investigation.json_data;
        if (typeof sectionStateData === 'string') {
          sectionStateData = JSON.parse(sectionStateData);
        }
        const fData = sectionData.aps_report_load.abusers.filter(
          abuser => abuser.perpetrator_also_the_caregiver === 'Yes'
        );
        fData.map(
          dataF => {
            const isSectionIdPresent = sectionData.aps_report_load.caregivers.filter(
              caregiver => caregiver.section_id === dataF.section_id
            );
            if (isSectionIdPresent.length === 0) {
              caregiverSyncData.push({
                ...dataF,
                first_name: dataF.first
              });
            } else {
              sectionStateData.aps_report_load.abusers.filter(
                abuserData => {
                  if ((abuserData.section_id === dataF.section_id)
                    && (dataF.perpetrator_also_the_caregiver !== abuserData.perpetrator_also_the_caregiver)) {
                      return abuserData;
                  }
                }
              ).map(
                cData => {
                  caregiverData = sectionData.aps_report_load.caregivers.map(
                    ccData => {
                      if (ccData.section_id === cData.section_id) {
                        return {
                          ...dataF,
                          first_name: dataF.first,
                          caregiver_association_to_victim: ccData.caregiver_association_to_victim
                        };
                      }
                      return ccData;
                    }
                  );
                }
              );
            }
          }
        );
        if (caregiverData.length > 0 && caregiverSyncData !== undefined && caregiverSyncData.length > 0) {
          sectionData = {
            aps_report_load: {
              ...sectionData.aps_report_load,
              caregivers: [
                ...caregiverData,
                ...caregiverSyncData
              ],
              caregiverHasChange: true
            }
          };
        } else if (caregiverSyncData !== undefined && caregiverSyncData.length > 0) {
          sectionData = {
            aps_report_load: {
              ...sectionData.aps_report_load,
              caregivers: [
                ...sectionData.aps_report_load.caregivers,
                ...caregiverSyncData
              ],
              caregiverHasChange: true
            }
          };
        } else if (caregiverData.length > 0) {
          sectionData = {
            aps_report_load: {
              ...sectionData.aps_report_load,
              caregivers: [
                ...caregiverData
              ],
              caregiverHasChange: true
            }
          };
        }
      }
      return {
        ...data,
        investigation: {
          ...data.investigation,
          json_data: JSON.stringify(sectionData)
        }
      };
    }
    case FormDataActionTypes.LoadFormDataWithButtonSync: {
      let data = {...action.payload};
      let sectionData: any = {};
      let caregiverSyncData: any = {};
      let caregiverData: any = {};
      let isSectionIdPresentOnG = 0;
      let caregiverHasChange = false;
      sectionData = data.investigation.json_data;
      if (typeof sectionData === 'string') {
          sectionData = JSON.parse(sectionData);
      }
      const fData = sectionData.aps_report_load.abusers.filter(
        abuser => abuser.perpetrator_also_the_caregiver === 'Yes'
      );
      caregiverSyncData = fData.map(
        dataF => {
          let cFinalData = {};
          const isSectionIdPresent = sectionData.aps_report_load.caregivers.filter(
            caregiver => caregiver.section_id === dataF.section_id
          );
          if (isSectionIdPresent.length > 0) {
            isSectionIdPresentOnG = 1;
            isSectionIdPresent.map(
              caregiver => {
                cFinalData = {
                  ...dataF,
                  first_name: dataF.first,
                  caregiver_association_to_victim: caregiver.caregiver_association_to_victim
                };
              }
            );
            return cFinalData;
          }
        }
      );
      caregiverData = sectionData.aps_report_load.caregivers.filter(
        caregiver => {
          if ((caregiver.section_id === undefined || caregiver.section_id === null || caregiver.section_id === '')
            && ((caregiver.first_name !== undefined && caregiver.first_name !== null && caregiver.first_name !== '')
            && (caregiver.last_name !== undefined && caregiver.last_name !== null && caregiver.last_name !== ''))) {
            caregiverHasChange = true;
            return caregiver;
          }
        }
      );
      if (caregiverData.length > 0) {
        sectionData = {
          aps_report_load: {
            ...sectionData.aps_report_load,
            caregivers: [
              ...caregiverSyncData,
              ...caregiverData
            ],
            caregiverHasChange
          }
        };
      } else if (caregiverSyncData.length > 0) {
        caregiverHasChange = true;
        sectionData = {
          aps_report_load: {
            ...sectionData.aps_report_load,
            caregivers: [
              ...caregiverSyncData
            ],
            caregiverHasChange
          }
        };
      }
      data = {
        ...data,
        investigation: {
          ...data.investigation,
          json_data: JSON.stringify(sectionData)
        }
      };
      return data;
    }
    default:
      return state;
  }
}
